<template>
  <div class="condition">
    <Header  :title="'各类课表查询'+this.tittleName" type="0" :route="this.$route.query.singcont==1?'/homeIndex':'/teacher/surfaAll'" />
    <div >
      <van-cell
        title="学年学期"
        is-link
        icon="label-o"
        @click="xnxqPop = true"
        :value="xnxq.mc"
      />
      <!---
        <van-cell
        title="时间模式"
        is-link
        icon="label-o"
        @click="timePop = true"
        :value="timeMsVal.kbjcmsmc"
      />
        --->
      <van-cell
        readonly
        clickable
        icon="label-o"
        :value="nowDate"
        title="上课日期"
        @click="datePicker=true"
      />
      <van-calendar 
        v-model="datePicker" 
        color="@attendance-color-1"
        :show-title="false"
        :show-confirm="false"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onConfirm" 
        @cancel="datePicker = false"/>

        <van-cell
        title="节次"
        is-link
        icon="label-o"
        @click="jcPop = true"
        :value="jcMsVal.jctime"
      />
    </div>
    <div class="btn">
      <van-button type="primary" block color="#7469F8" @click="search"
        >查询</van-button
      >
    </div>
    <!-- 学年学期 -->
    <van-popup v-model="xnxqPop" position="bottom">
      <van-picker
        :columns="xnxqList"
        :item-height="35"
        show-toolbar
        @cancel="xnxqPop = false"
        @confirm="xnxqConfirm"
        :default-index="defaultXnxqIndex"
      ></van-picker>
    </van-popup>
    <!-- 时间模式 -->
    <van-popup v-model="timePop" position="bottom">
      <van-picker
        :columns="timeList"
        :item-height="35"
        show-toolbar
        @cancel="timePop = false"
        @confirm="timeConfirm"
        :default-index="defaultJcmsIndex"
      ></van-picker>
    </van-popup>

    <van-popup v-model="jcPop" position="bottom">
      <van-picker
        :columns="jcList"
        :item-height="35"
        show-toolbar
        @cancel="jcPop = false"
        @confirm="jcConfirm"
        default-index="0"
      ></van-picker>
    </van-popup>
  </div>
</template>
<script>
import { Api } from "@/utils/axios";
export default {
  data() {
    return {
      type: this.$route.query.findType,
      xnxqPop: false,
      timePop: false,
      jcPop:false,
      datePicker:false,
      minDate:new Date(2015,0,1),
      maxDate:new Date(2030,0,1),
      xnxqList: [],
      timeList:[],
      jcList:[],
      form: {
        xnxq: "",
      },
      xnxq: {},
      timeMsVal: {
        sjmsid:"",
        kbjcmsmc:"",
      },
      jcMsVal:{
        jcName:'',
        jcTime:''
      },
      initTimeList:{},
      initXnxqList:{},
      initJcTimeList:{},
      searchVal:"",
      searchName: "",
      defaultXnxqIndex:0,
      defaultJcmsIndex:0,
      tittleName:"(分时间段)",
      timer:Math.random()*100*Math.random(),
      nowDate:''
    };
  },
  created() {
     this.searchVal = this.$route.query.searchVal;
     this.searchName = this.$route.query.searchName;
    //初始化数据
    this.initData();
  },  
  methods: {
    //初始化数据
    async initData(){
      const params = {
          xnxq:'',
        }
       const res = await Api.initCurAllData(params);
       this.initTimeList = res.data.sjList;
       this.initXnxqList = res.data.xnxqList;
       this.initJcTimeList = res.data.jcTimeList;
       this.nowDate = res.data.nowDate;
       this.setXnxq();
       this.setTimeObj();
       this.setJcTime();
    },
    async changJcMsg(){
      const params = {
          xnxq:this.xnxq.dm,
          kbjcmsid:this.timeMsVal.sjmsid
        }
      const res = await Api.initCurAllData(params);  
      this.initJcTimeList = res.data.jcTimeList;
      this.setJcTime();
    },
    // 获取学年学期
    setXnxq() {
       for(let i=0;i<this.initXnxqList.length;i++){
         if(this.initXnxqList[i].isdqxq=='1'){
              this.defaultXnxqIndex = i;
              this.xnxq = {
                dm: this.initXnxqList[i].xnxq01id,
                mc: this.initXnxqList[i].xqmc
              };
         }
         this.xnxqList.push({'value': this.initXnxqList[i].xnxq01id, 'text': this.initXnxqList[i].xqmc});
      }
    },
    setTimeObj() {
      for(let i=0;i<this.initTimeList.length;i++){
            this.timeList.push({'value': this.initTimeList[i].kbjcmsid, 'text': this.initTimeList[i].kbjcmsmc});
            if(this.initTimeList[i].mrms=='1'){
              this.defaultJcmsIndex = i;
              this.timeMsVal ={
                  sjmsid:this.initTimeList[i].kbjcmsid,
                  kbjcmsmc:this.initTimeList[i].kbjcmsmc,
              } 
            }
		} 
    },
    setJcTime(){
      let isdqjc=0;
      for(let i=0;i<this.initJcTimeList.length;i++){
            this.jcList.push({'value': this.initJcTimeList[i].jc, 'text': this.initJcTimeList[i].jc+"节("+this.initJcTimeList[i].jctime+")"});
            if(this.initJcTimeList[i].dqjc=='1'&&isdqjc==0){
              isdqjc = 1;
              this.jcMsVal ={
                  jcName:this.initJcTimeList[i].jc,
                  jctime:this.initJcTimeList[i].jc+"节("+this.initJcTimeList[i].jctime+")",
              } 
            }
		} 
    },
    formatDate(date) {
      return `${date.getFullYear()}-${(date.getMonth() + 1)>=10?(date.getMonth() + 1):('0'+(date.getMonth() + 1))}-${date.getDate()>=10?date.getDate():('0'+date.getDate())} `;
    },
    onConfirm(e){
      this.nowDate = this.formatDate(e)
      this.datePicker = false
    },
    xnxqConfirm(value) {
      this.xnxq.mc = value.text;
      this.xnxq.dm = value.value;
      this.xnxqPop = false;
      this.changJcMsg();
    },
    timeConfirm(e) {
      this.timeMsVal.sjmsid = e.value;
      this.timeMsVal.kbjcmsmc = e.text;
      this.timePop = false;
      this.changJcMsg();
    },
    jcConfirm(e) {
      this.jcMsVal.jcName = e.value;
      this.jcMsVal.jctime = e.text;
      this.jcPop = false;
    },
    search() {
      if(!this.xnxq||this.xnxq.dm==''){
        this.$toast.fail("请选择学年学期！"); 
        return;
      }
      if(this.nowDate==''){
        this.$toast.fail("请选择上课日期！"); 
        return;
      }
      if(this.jcMsVal.jcName==''){
        this.$toast.fail("请选择节次！"); 
        return;
      }
      this.$router.push({
        path: "/teacher/searchCurAllList_time",
        query: {
          xnxq: this.xnxq.dm,
          kbsjmsid:this.timeMsVal.sjmsid,
          findType:this.type,
          searchVal:this.searchVal,
          searchName:this.searchName,
          jcName:this.jcMsVal.jcName,
          dateTime:this.nowDate,
          jcMsg:this.jcMsVal.jctime
        }
      });
    }
  }
};
</script>
<style scoped lang="less">
.condition {
  .btn {
    position: fixed;
    bottom: 1.25rem;
    padding: 0 1.25rem;
    width: 100%;
    left: 0;
    box-sizing: border-box;
  }
  /deep/.alter-pop.van-popup.van-popup--bottom {
    max-height: 100% !important;
    min-height: 100% !important;
}
}
</style>



// WEBPACK FOOTER //
// src/components/teacher/teachCuseAll/findViwe_time.vue